import React from 'react';

import HeaderLogin from 'components/Header/HeaderLogin';
import Bottom from 'components/Bottom';
import ContentLogin from './ContentLogin';

const LoginDireto = () => {
  return (
    <>
      <HeaderLogin />
      <ContentLogin />
      <Bottom />
    </>
  );
};

export default LoginDireto;
